import { BadgeCheck } from "lucide-react";
import { useSite } from "@/context/SiteContext";

export default function LegalSection({ items }) {
  const { t } = useSite();
  if (!items?.length) return null;
  return (
    <section id="legalitas" className="py-16 sm:py-24" data-testid="legal-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <p className="eyebrow mb-4">{t("legal.eyebrow")}</p>
        <h2 className="mb-10 text-3xl font-bold tracking-tight text-[#0F2B48] lg:text-4xl">{t("legal.title")}</h2>
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {items.map((l, i) => (
            <div key={i} className="border border-slate-200 bg-white p-5 transition-colors hover:border-[#D97706]" data-testid={`legal-item-${i}`}>
              <BadgeCheck size={22} className="text-[#D97706]" />
              <p className="mt-3 font-semibold text-[#0F2B48]">{l.name}</p>
              {l.number && <p className="mt-2 font-mono text-xs text-slate-500">{t("legal.number")}: {l.number}</p>}
              {l.issuer && <p className="font-mono text-xs text-slate-500">{t("legal.issuer")}: {l.issuer}</p>}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
